import React, { Component } from 'react';
import './Component.css';

class Navi extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showNaviCity: false
		}

		this.handleWindowScroll = this.handleWindowScroll.bind(this);
	}

	handleWindowScroll() {
		let cities = document.getElementById('navmarker');

		if ((cities.offsetTop - window.pageYOffset) < 300) {
			if (!this.state.showNaviCity) this.setState({ showNaviCity: true });
			window.removeEventListener('scroll', this.handleWindowScroll);
		}
	}


	componentDidMount() {
		window.addEventListener('scroll', this.handleWindowScroll);
	}

	render() {
		if (this.state.showNaviCity) {
		return (
			<div className={this.state.showNaviCity ? "Navi-city" : "Header-city"} id="city-buttons">

				<div className="city-buttons">
					{ this.props.cities.map(
						(city) => {
							let selectedClass = "city-button";
							if (this.props.city === city) selectedClass = "city-button selected";
							return (
								<button 
									className={selectedClass} 
									key={city}
									onClick={this.props.handleNaviCityButtonClick.bind(this, city)}>
									{city.charAt(0).toUpperCase() + city.slice(1)}
								</button>
							);
						}
					)}
				</div>

			</div>
		);
	} else {
		return <div id="navmarker"></div>
	}
	}
}

export default Navi;


// WEBPACK FOOTER //
// ./src/Navi.js